export default __webpack_public_path__ + "static/media/5.9.9bd5aeda.mp3";